import { MojeHeader } from "../components/header/MojeHeader"
import { MojeFooter } from "../components/MojeFooter"
import {
  SectionHeader,
  NumberList,
  AlphaList,
} from "../components/typo/PolicyTypography"

export default function PrivacyPage() {
  return (
    <div>
      <MojeHeader venueMode showSearch scrollable />
      <div className="max-w-screen-lg mx-auto p-5 pl-8 min-h-screen leading-6 md:text-justify privacy-page">
        <h1 className="text-center text-lg font-bold mb-6">
          Polityka prywatności MojeUrodziny.pl
        </h1>
        <SectionHeader number={1}>postanowienia ogólne</SectionHeader>
        <NumberList>
          <li>
            Polityka prywatności posługuje się pojęciami wprowadzonymi i
            wyjaśnionymi w Regulaminie Serwisu MojeUrodziny.pl (dalej:
            Regulamin), które w niniejszym dokumencie mają tożsame znaczenie jak
            we wskazanym Regulaminie, dostępnym pod adresem{" "}
            <a href="https://www.mojeurodziny.pl/warunki">
              https://www.mojeurodziny.pl/warunki
            </a>{" "}
            chyba że w Polityce prywatności wprost wskazane zostało znaczenie
            inne.
          </li>
          <li>
            Polityka prywatności określa zasady przetwarzania i ochrony danych
            osobowych przekazanych Operatorowi, dalej zwanym także
            Administratorem danych, przez Usługodawców będących osobami
            fizycznymi, które przetwarzane są w celach innych niż przewidzianych
            obowiązującymi przepisami prawa. Za każdym razem, kiedy w Polityce
            prywatności jest mowa o Usługodawcach, należy przez to rozumieć
            wyłącznie osoby fizyczne, które przekazały dane osobowe w celu
            umożliwienia świadczenia na ich rzecz Usług oferowanych przez
            Serwis, a także osoby fizyczne, które nie dokonały Rejestracji w
            Serwisie, ale korzystają z Serwisu, w Regulaminie określane jako
            Użytkownicy.
          </li>
          <li>
            Polityka prywatności określa także zasady przetwarzania i ochrony
            danych osobowych przekazanych Administratorowi danych przez Klientów
            w związku z korzystaniem przez nich z Serwisu, jak również dane
            osobowe końcowych odbiorców Usług oferowanych w Serwisie, to jest
            dzieci i młodzieży, przy czym w przypadku osób, które nie ukończyły
            16 roku życia, konieczne jest wyrażenie zgody na przetwarzanie ich
            danych osobowych przez opiekuna prawnego. Polityka prywatności w
            celach związanych z określeniem zasad przetwarzania danych
            osobowych, jako Klientów określa także wyżej wskazanych odbiorców
            końcowych Usług oferowanych w Serwisie.
          </li>
          <li>
            Dane osobowe Usługodawców i Klientów przetwarzane są zgodnie
            przepisami powszechnie obowiązującego prawa, w tym w szczególności z
            Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia
            27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z
            przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
            takich danych oraz uchylenia dyrektywy 95/46/WE (dalej: RODO) oraz
            przepisami krajowymi uchwalonym w wykonaniu lub w związku z RODO .
          </li>
          <li>
            Niniejsza Polityka prywatności ma charakter informacyjny i nie
            stanowi źródła obowiązków dla Usługodawców i Klientów.
          </li>
        </NumberList>
        <SectionHeader number={2}>dane osobowe</SectionHeader>
        <NumberList>
          <li>
            Administrator danych przetwarza dane osobowe udostępniane przez
            Usługodawców i Klientów podczas Rejestracji w Serwisie, w celu
            umożliwienia korzystania z funkcjonalności Serwisu dostarczanych
            przez Operatora oraz w celu umożliwienia korzystania z Usług
            oferowanych za pośrednictwem Serwisu. Administrator danych
            przetwarza następujące dane udostępnione mu przez Usługodawców i
            Klientów: imię i nazwisko, adres zamieszkania, telefon oraz adres
            e-mail, kraj (dalej: Dane osobowe). W przypadku przedsiębiorców,
            wskazany zakres Danych osobowych jest poszerzony o firmę
            przedsiębiorcy oraz jego NIP.
          </li>
          <li>
            Administratorem danych osobowych jest spółka Julia Chruścielewska,
            prowadząca działalność gospodarczą pod firmą Mente Julia
            Chruścielewska, Plac Zwycięstwa 2, 90-312 Łódź, NIP: 7251944860.
          </li>
          <li>
            Usługodawcy i Klienci mogą skontaktować się z Administratorem danych
            za pośrednictwem: poczty elektronicznej – urodziny@mojeurodziny.pl
          </li>
          <li>
            Odbiorcą Danych osobowych jest PayPro S.A. z siedzibą w Poznaniu,
            ul. Kanclerska 15, 60-327 Poznań, z którą Administrator danych
            współpracuje w celu obsługi płatności dokonywanych przez
            Usługodawców na rzecz Operatora oraz Klientów na rzecz Usługodawców.
          </li>
          <li>
            Administrator danych może powierzyć przetwarzanie zebranych Danych
            osobowych Usługodawców i Klientów innemu podmiotowi w oparciu o
            zawartą z nim umowę powierzenia przetwarzania danych osobowych
            (odbiorca danych), przy czym podmioty te zobowiązane zostaną do
            przestrzegania zasad poufności i bezpieczeństwa, w szczególności
            nieudostępniania Danych osobowych osobom nieuprawnionym, oraz do
            stosowania organizacyjnych, technicznych i fizycznych środków
            bezpieczeństwa, adekwatnych do sposobu przetwarzania tych danych. Te
            podmioty to w szczególności dostawcy usług zaopatrujący
            Administratora danych w rozwiązania informatyczne, techniczne i
            organizacyjne, umożliwiające prowadzenie działalności, w tym strony
            internetowej i świadczonych za jej pośrednictwem usług
            elektronicznych, a także dostawcy usług prawnych, księgowych i
            doradczych zapewniający Administratorowi danych wsparcie w tych
            zakresach.
          </li>
          <li>
            W przypadku dokonania przez Klienta Rezerwacji Usługi oferowanej w
            Serwisie, Administrator danych przekaże stronom zawartej umowy o
            świadczenie usług wzajemne Dane osobowe w celu umożliwienia jej
            prawidłowego wykonania, a także w celu wystawienia dokumentu
            sprzedaży zgodnie z obowiązującymi przepisami.{" "}
          </li>
          <li>
            Administrator danych w celu zapewnienia wysokiej jakości świadczonej
            usługi i użyteczności oraz optymalizacji Serwisu, może korzystać z
            zewnętrznych narzędzi analitycznych na zasadzie zautomatyzowanego
            zbierania części danych o Usługodawcach i Klientach, m.in. za pomocą
            narzędzi typu google analytics i hotjar.com. Na stronach
            internetowych tych narzędzi są udostępnione regulaminy, polityki
            prywatności oraz inne dokumenty wewnętrzne, z którymi Usługodawcy i
            Klienci mogą się zapoznać i których treści akceptują, akceptując
            Politykę prywatności.
          </li>
          <li>
            Usługodawcy i Klienci mogą zgłosić do Administratora danych prośbę o
            usunięcie części zewnętrznych narzędzi, przy czym prośba ta nie jest
            dla Administratora danych wiążąca, a o finalnej decyzji Usługodawcy
            i Klienci zostanie powiadomiony drogą mailową.
          </li>
        </NumberList>
        <SectionHeader number={3} />
        <NumberList>
          <li>
            Administrator danych przetwarza Dane osobowe Usługodawców i Klientów
            wyłącznie w celu umożliwienia korzystania z funkcjonalności Serwisu
            dostarczanych przez Operatora oraz w celu umożliwienia korzystania z
            Usług oferowanych za pośrednictwem Serwisu.
          </li>
          <li>
            Udostępnienie Danych osobowych jest dobrowolne, przy czym niezbędne
            dla udzielenia Usługodawcom i Klientom dostępu do wybranych przez
            nich funkcjonalności Serwisu oraz Usług oferowanych przez
            Usługodawców za pośrednictwem Serwisu.
          </li>
          <li>
            Przetwarzanie Danych osobowych jest niezbędne między innymi w celu:
          </li>
          <AlphaList>
            <li>
              wykonania umowy, której stroną jest osoba, której dane dotyczą,
              lub do podjęcia działań na żądanie osoby, której dane dotyczą,
              przed zawarciem umowy – art. 6 ust. 1 lit. b) RODO,
            </li>
            <li>
              wywiązania się przez Administratora danych z obowiązków
              rachunkowych powstałych w przypadku świadczenia na rzecz
              Usługodawców odpłatnych usług – art. 6 ust. 1 lic. c) RODO,
            </li>
            <li>
              udzieleniu odpowiedzi na pytania zadane za pośrednictwem
              znajdującego się w Serwisie formularza umożliwiającego kontakt z
              Administratorem danych – art. 6 ust. 1 lit. a) RODO; Dane osobowe
              mogą być przetwarzane do momentu zakończenia sprawy przedstawionej
              przez Usługodawcę bądź Klienta lub do momentu wycofania jego zgody
              na przetwarzanie Danych osobowych; w niektórych przypadkach, w
              zależności od treści wiadomości przesłanej za pośrednictwem
              formularza kontaktowego, Dane osobowe mogą być poddane
              archiwizacji na podstawie prawnie uzasadnionego interesu
              Administratora danych, w celu wykazania przebiegu rozmowy w
              przyszłości (np. w przypadku roszczeń Usługodawcy) – art. 6 ust. 1
              lit. f) RODO,
            </li>
          </AlphaList>
          <li>
            W przypadku wyrażenia przez Usługodawców i Klientów dodatkowej i
            dobrowolnej zgody, ich Dane osobowe mogą być przetwarzane w celach
            marketingowych związanych z usługami oferowanymi przez
            Administratora danych. W przypadku wyrażenia zgody, Dane osobowe
            będą przetwarzane w celach marketingowych do chwili do jej
            cofnięcia, co może nastąpić w każdym czasie, w sposób wskazany w § 3
            ust. 6. Podczas przetwarzania Danych osobowych w celach
            marketingowych, Administrator danych respektuje wszelkie uprawnienia
            kontrolne przysługujące Usługodawcom i Klientom, które mogą być
            realizowane w sposób i na zasadach wskazanych w § 4 ust. 1-5.
          </li>
          <li>
            W przypadku wyrażenia przez Usługodawców i Klientów dodatkowej i
            dobrowolnej zgody, ich dane osobowe mogą być wykorzystane w celu
            przekazania informacji handlowych na temat usług oferowanych przez
            Administratora danych, za pomocą środków komunikacji elektronicznej
            w rozumieniu ustawy z dnia 18 lipca 2002 roku o świadczeniu usług
            drogą elektroniczną, w formie wiadomości tekstowych (sms) oraz za
            pośrednictwem poczty elektronicznej, na temat usług oferowanych
            przez Operatora. W przypadku wyrażenia zgody, informacje handlowe
            będą przekazywane za pomocą środków komunikacji elektronicznej do
            chwili jej cofnięcia, co może nastąpić w każdym czasie, w sposób
            wskazany w § 3 ust. 8. Wykorzystując Dane osobowe w celu przekazania
            informacji handlowych w sposób wskazany powyżej, Administrator
            danych respektuje wszelkie uprawnienia kontrolne przysługujące
            Usługodawców i Klientów, które mogą być realizowane w sposób i na
            zasadach wskazanych w § 4 ust. 1-5.
          </li>
          <li>
            Zgody wyrażone przez Usługodawców i Klientów, o których mowa w § 3
            ust. 4 i 5, mogą zostać przez nich w każdej chwili odwołane, bez
            wpływu na zgodność z prawem przetwarzania, poprzez wysłanie
            stosownego żądania za pośrednictwem poczty elektronicznej, na adres
            email urodziny@mojeurodziny.pl
          </li>
          <li>
            W przypadku udostępnienia Danych osobowych wyłącznie w celu
            uzyskania dostępu do wybranych funkcjonalności świadczonych przez
            Administratora danych w Serwisie lub oferowanych przez Usługodawców
            za pośrednictwem Serwisu, Dane osobowe przetwarzane będą przez czas
            niezbędny dla prawidłowego realizowana tychże funkcjonalności i
            Usług, chyba że Usługodawca i/lub Klient wyrażą zgodę na
            przetwarzanie udostępnionych przez nich Danych osobowych także po
            zakończeniu świadczenia na ich rzecz Usług.
          </li>
          <li>
            Okres przetwarzania danych może być przedłużony w przypadku, gdy
            przetwarzanie jest niezbędne do ustalenia, dochodzenia lub obrony
            przed ewentualnymi roszczeniami, a po tym okresie, jedynie w
            przypadku i w zakresie, w jakim będą wymagać tego przepisy prawa.
          </li>
        </NumberList>
        <SectionHeader number={4}>prawo kontroli</SectionHeader>
        <NumberList>
          <li>
            Każdemu Usługodawcy i Klientowi przysługuje w każdym czasie prawo
            dostępu do treści swoich Danych osobowych oraz ich poprawiania.
          </li>
          <li>
            Administrator danych respektuje wszelkie uprawnienia przysługujące
            Usługodawcom i Klientom, w tym w szczególności prawo żądania
            aktualizacji Danych osobowych, ich poprawiania i usunięcia, które
            mogą być realizowane przez Usługodawców i Klientów w dowolnym
            momencie, chyba że ich realizację uniemożliwiają obowiązujące
            przepisy prawa.
          </li>
          <li>
            Usługodawcom i Klientom przysługuje także prawo wniesienia sprzeciwu
            w przypadkach określonych w przepisach RODO, jak również prawo do
            ograniczenia przetwarzania danych oraz przeniesienia danych, a także
            prawo do cofnięcia udzielonej zgody w dowolnym momencie bez wpływu
            na zgodność z prawem przetwarzania.
          </li>
          <li>
            Uprawnienia wskazane w § 4 ust. 2 i 3 mogą być realizowane poprzez
            wysłanie stosownego żądania za pośrednictwem poczty elektronicznej,
            na adres urodziny@mojeurodziny.pl
          </li>
          <li>
            W przypadku uznania, iż przetwarzanie Danych osobowych następuje z
            naruszeniem obowiązujących przepisów, każdemu Usługodawcy i
            Klientowi przysługuje prawo wniesienia skargi do Organu nadzorczego,
            to jest Prezesa Urzędu Ochrony Danych Osobowych.
          </li>
        </NumberList>
        <SectionHeader number={5}>bezpieczeństwo</SectionHeader>
        <NumberList>
          <li>
            Administrator danych stosuje odpowiednie organizacyjne, techniczne i
            fizyczne zabezpieczenia mające na celu ochronę Danych osobowych
            przed przypadkowym, bezprawnym lub nieautoryzowanym zniszczeniem,
            utratą, zmianą, dostępem, ujawnieniem lub wykorzystaniem.
          </li>
          <li>
            Administrator danych zapewnia, że dostęp do Danych osobowych mają
            jedynie osoby przez niego upoważnione i wyłącznie w zakresie, w
            jakim jest to niezbędne ze względu na wykonywane przez nie zadania.
          </li>
        </NumberList>
        <SectionHeader number={6}>pliki cookies</SectionHeader>
        <NumberList>
          <li>
            Serwis korzysta z plików cookies. Pliki cookies (tzw. „ciasteczka”)
            stanowią dane informatyczne, w szczególności pliki tekstowe, które
            przechowywane są w urządzeniu końcowym Usługodawcy i Klienta i
            przeznaczone są do korzystania ze strony internetowej Serwisu. Pliki
            tego rodzaju zazwyczaj zawierają nazwę strony internetowej, z której
            pochodzą, czas przechowywania ich na urządzeniu końcowym oraz
            unikalny numer.
          </li>
          <li>
            Pliki cookies, poza plikami, których zastosowanie jest niezbędne dla
            prawidłowego funkcjonowania Serwisu, wykorzystywane są za zgodą
            Usługodawcy i Klienta, wyrażoną poprzez odpowiednie ustawienie
            oprogramowania, w szczególności przeglądarki internetowej,
            zainstalowanego w urządzeniu elektronicznym, wykorzystywanym przez
            Usługodawcę i Klienta. Pliki cookies wykorzystywane są w
            szczególności w celach statystycznych i funkcjonalnych
          </li>
          <li>Na stronie Serwisu używane są dwa rodzaje plików cookies:</li>
          <AlphaList>
            <li>
              sesyjne – pozostają zapisane na komputerze lub urządzeniu mobilnym
              do momentu opuszczenia strony internetowej lub wyłączenia
              przeglądarki internetowej,
            </li>
            <li>
              stałe – pozostają na komputerze lub urządzeniu mobilnym przez czas
              określony w parametrach plików cookies lub do momentu ich ręcznego
              usunięcia w przeglądarce internetowej.{" "}
            </li>
          </AlphaList>
          <li>
            Serwis wykorzystuje również dane w LocalStorage i SessionStorage,
            które pozostają na urządzeniu Usługodawcy i Klienta przez czas
            określony w parametrach plików cookies lub do momentu ich ręcznego
            usunięcia w przeglądarce internetowej.{" "}
          </li>
          <li>
            Ograniczenia lub wyłączenie przez Usługodawcę lub Klienta stosowania
            plików cookies jest możliwe w każdym czasie, jednak będzie miało
            negatywny wpływ na niektóre funkcje dostępne w Serwisie lub
            całkowicie uniemożliwi jego poprawne wyświetlenie i działanie. W
            celu zachowania pełnej możliwości korzystania z Usług, Administrator
            danych zaleca niedokonywanie modyfikacji w ustawieniach cookies.
          </li>
        </NumberList>
        <SectionHeader number={7}>postanowienia końcowe</SectionHeader>
        <NumberList>
          <li>Niniejsza Polityka prywatności obowiązuje od dnia 15.06.2021</li>
          <li>
            Niniejsza Polityka prywatności jest na bieżąco weryfikowana i w
            razie potrzeby aktualizowana.
          </li>
          <li>
            W przypadku zmiany treści Polityki prywatności, Administrator danych
            każdorazowo poinformuje Usługodawców i Klientów o tym fakcie poprzez
            zamieszczenie informacji o zmianach za pośrednictwem Serwisu lub
            poprzez wysłanie wiadomości na adresy e-mail wskazane podczas
            Rejestracji. Stosowna informacja pojawi się z przynajmniej
            siedmiodniowym wyprzedzeniem wprowadzenia w życie zmian w treści
            Polityki prywatności.
          </li>
        </NumberList>
      </div>
      <MojeFooter />
    </div>
  )
}
